import React from 'react'
// import PropTypes from 'prop-types'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';


export default class Theme extends React.Component {

  render() {
    const {
      children,
    } = this.props

    const colorGold = '#998778';
    const colorSilver = '#6b6b6b';
    const theme = createMuiTheme({
      palette: {
        primary: {main: colorGold, light: colorGold, dark: colorGold, contrastText: '#fff'},
        secondary: {main: colorSilver, light: colorSilver, dark: colorSilver, contrastText: '#fff'}
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920
        }
      },
      overrides: {
        MuiButton: {
          root: {
            color: colorGold, // Some CSS
            backgroundColor: '#eee'
          },
        },
        MuiInput: {
          root: {
            color: colorGold
          },
        }
      },

    });

// console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return (
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx